import { render, staticRenderFns } from "./appraisalBindQuestionBankList.vue?vue&type=template&id=c5c39efc"
import script from "./appraisalBindQuestionBankList.vue?vue&type=script&lang=js"
export * from "./appraisalBindQuestionBankList.vue?vue&type=script&lang=js"
import style0 from "./appraisalBindQuestionBankList.vue?vue&type=style&index=0&id=c5c39efc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports